module.exports = __webpack_public_path__ + "img/email_parent.f3feb86d.svg";